import { gql } from "@apollo/client";

export const CONTACT_POINT = gql`
    query ContactPoint($culture: String!) {
        contactPoint(
            where: {localization: {culture: $culture}}
            orderBy: {publishedUtc: DESC}
        ) {
            address
            displayText
            email
            mailBox
            phone
            visibleInContactUs
            code {
                code
            }
            location {
                latitude
                longitude
            }
            icon {
                paths
            }
        }
        feedbackType(
            orderBy: {createdUtc: ASC}
            where: {localization: {culture: $culture}}
        ) {
            code {
                code
            }
            displayText
        }
        feedbackCategory(
            orderBy: {createdUtc: ASC}
            where: {localization: {culture: $culture}}
            ) {
            code {
                code
            }
            displayText
        }
    }
`;